function AddDamageController() {
    this.constructor.apply(this, arguments);
}

AddDamageController.$inject = ['$mdPanel', 'close', '$translationService', '$q', 'damage', 'AttackmentService', 'UtilityService', 'VehicleBookingService', 'CameraService'];
AddDamageController.prototype = {
    /**
     *
     * @param $mdPanel {$mdPanel}
     * @param close {Function}
     * @param $translationService {$translationService}
     * @param $q {$q}
     * @param damage {IVehicleDamage}
     * @param AttackmentService {AttackmentService}
     * @param UtilityService {UtilityService}
     * @param VehicleBookingService {VehicleBookingService}
     * @param CameraService {CameraService}
     */
    constructor($mdPanel, close, $translationService, $q, damage, AttackmentService, UtilityService, VehicleBookingService, CameraService) {
        this.$mdPanel = $mdPanel;
        this.close = close;
        this.$translationService = $translationService;
        this.$q = $q;
        this.attackmentService = AttackmentService;
        this.utilityService = UtilityService;
        this.vehicleBookingService = VehicleBookingService;
        this.cameraService = CameraService;

        /** @type {IAttachment[]} */
        this.$files = [];

        /** @type {IVehicleDamage} */
        this.damage = damage;

        /** @type {IVehicleDamageLocationItem} */
        this.location = null;

        /** @type Object */
        this.attachmentsOptions = {width: '100%'};


        if (damage && damage.Location) {
            this.location = this.vehicleBookingService.getLocations().find((location) => {
                return location.Name === damage.Location;
            })
        }

        // Restore photo
        if(this.damage.DocumentId){
            let file = this.vehicleBookingService.getAttachmentFromDamage(this.damage);
            this.$files.push(file);
        }

    },


    ready() {
        this.$element = $('#internal-add-damage-dialog');
    },

    goBack(data) {
        this.close(data);
    },
    /**
     *
     * @param $event {MouseEvent}
     */
    showLocationPickerModal($event) {
        let selectedItems = this.location ? [this.location] : [];
        let panelRef = this.$mdPanel.create({
            controller: VirtualListSelectorController,
            controllerAs: 'vm',
            templateUrl: 'js/shared/virtual-list-selector/virtual-list-selector.view.html',
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: false,
            hasBackdrop: true,
            panelClass: 'virtual-list-selector-panel damage-location-panel',
            zIndex: 90,
            fullscreen: true,
            locals: {
                onClose: (result) => {
                    return panelRef.close(result).finally(() => {
                        if (result) {
                            this.location = result;
                            this.damage.Location = result.Name;
                        }
                    })
                },
                loadData: (options) => {
                    let locations = this.vehicleBookingService.getLocations();
                    return this.$q.resolve({
                        Rows: locations,
                        TotalCount: locations.length
                    });
                },
                title: this.$translationService.getTranslation('Location'),
                selectedItems: selectedItems,
                options: {
                    itemSize: 46,
                    searchable: false,
                    multiple: false,
                    lazyLoad: false,
                    templateItem: 'location-item-template',
                }
            }
        });
        return panelRef.open().then((panel) => {
            panel._config.scope.vm.ready();
        });
    },



    showPhotos($event) {
        this.cameraService
            .showPhotosOrDocumentsPanel($event, {
                onStart: () => {
                },
                acceptOnlyPicture: true
            })
            .then((data) => {
                if (data) { // have file
                    if (!Array.isArray(data)) { // Convert to array if have a file
                        data = [data];
                    }
                    if (data.length > 0) {
                        this.uploadEventFiles(data);
                    }
                }
            });
    },
    uploadEventFiles($files) {
        this.attachmentsOptions.width = this.$element.find('nf-attachments').width();
        this.$files = Array.prototype.concat([], this.attackmentService.getFiles($files));
    },



    submit() {

        if (!this.attackmentService.checkFiles(this.$files)) {
            return;
        }


        /** @type {IVehicleDamage} */
        let data = {
            Location: this.damage.Location,
            Description: this.damage.Description,
            isNew : this.damage.isNew,
            Id: this.damage.Id||this.utilityService.createUUID()
        };

        if (this.$files.length > 0) {
            data.DocumentId = this.$files[0].DocumentId;
            data.DocumentName = this.$files[0].Name;
            data.ThumbnailUrl = this.$files[0].ThumbnailUrl;
            data.DownloadUrl = this.$files[0].DownloadUrl;
        }
        this.close(data);
    },

}
angular.module('internal.vehiclebookings').controller('AddDamageController', AddDamageController);